import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "offer-verified__hotel" }
const _hoisted_2 = { class: "offer-verified__hotel-name" }

import HotelStars from '@lmt-rpb/HotelStars/HotelStars.vue';
import { computed } from 'vue';
import { isClientGermany } from '@utils/environmentUtils';
import type { ClientType } from '@/interfaces/common';

interface Props {
	name: string;
	category: number;
	client?: ClientType;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OfferVerifiedHotelName',
  props: {
    name: {},
    category: {},
    client: { default: 'at' }
  },
  setup(__props: any) {

const props = __props;

const showSuns = computed(() => isClientGermany(props.client));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.name), 1 /* TEXT */),
    _createVNode(HotelStars, {
      rating: _ctx.category,
      "show-suns": showSuns.value,
      class: "offer-verified__hotel-stars"
    }, null, 8 /* PROPS */, ["rating", "show-suns"])
  ]))
}
}

})